import { render, staticRenderFns } from "./_base-overlay.vue?vue&type=template&id=63cafd20&scoped=true"
import script from "./_base-overlay.vue?vue&type=script&lang=js"
export * from "./_base-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cafd20",
  null
  
)

export default component.exports